
import { PropType, defineComponent } from 'vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import TextInput from '~/components/Inputs/Text.vue';
import { Filter } from '@/interfaces/filter';

export default defineComponent({
  name: 'MultiselectFilterWithSearch',

  components: { CustomButton, TextInput },

  props: {
    items: { type: Array as PropType<Filter[]>, required: true },
  },

  data: () => ({
    selected: [] as string[],
    selectedItem: '',
    search: '',
  }),

  computed: {
    filteredItems() {
      const needle = this.search.toLowerCase();
      return this.items.filter(item => item.label.toLowerCase().includes(needle));
    },

    allSelected() {
      return this.selected.length === this.items.length;
    }
  },

  methods: {
    isSelected(item: string) {
      return this.selected.indexOf(item) !== -1;
    },

    updateAndFilter(item: string, value: boolean) {
      if (value) this.selected.push(item);
      else this.selected.splice(this.selected.indexOf(item), 1);

      this.$emit('update:items', this.selected);
    },

    clearSelection() {
      this.selected = [];
      this.$emit('update:items', []);
    },

    selectAll() {
      this.selected = this.allSelected ? [] : this.items.map(item => item.label);

      this.$emit('update:items', this.selected);
    },
  }
});
